import { IHttpApi } from '@cian/http-api/shared';

import { assertUnknownError } from './assert';
import { mapDeleteOfferFromComparisonResponse, mapDeleteOfferFromComparisonResponseError } from './mappers';
import {
  fetchDeleteOfferFromComparison,
  TDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonResponse,
} from '../../../repositories/offers-comparison/v1/delete-offer-from-comparison';

export async function deleteOfferFromComparisonRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TDeleteOfferFromComparisonRequest;
}): Promise<TDeleteOfferFromComparisonResponse> {
  const response = await fetchDeleteOfferFromComparison({
    httpApi,
    parameters,
    config: {},
    mappers: {
      200: mapDeleteOfferFromComparisonResponse,
      400: mapDeleteOfferFromComparisonResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as TDeleteOfferFromComparisonResponse;
}
